import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import { getReducers } from './reducers';

export const store = createStore(getReducers(), composeWithDevTools(applyMiddleware(thunkMiddleware)));
